(function () {
  const storeTimezone = "America/Los_Angeles";
  const storeTimeOffset = parseInt("0", 10) || 0;

  function getClockParts() {
    const now = new Date();
    now.setMinutes(now.getMinutes() + storeTimeOffset);

    let options;
    let dateOptions;

    try {
      options = {
        timeZone: storeTimezone,
        hour: "numeric",
        minute: "numeric",
        hour12: true,
        timeZoneName: "short"
      };
      dateOptions = {
        timeZone: storeTimezone,
        year: "numeric",
        month: "2-digit",
        day: "2-digit"
      };
    } catch (e) {
      console.warn("Invalid timezone, falling back to local time", e);
      options = {
        hour: "numeric",
        minute: "numeric",
        hour12: true,
        timeZoneName: "short"
      };
      dateOptions = {
        year: "numeric",
        month: "2-digit",
        day: "2-digit"
      };
    }

    const formatter = new Intl.DateTimeFormat("en-US", options);
    const dateFormatter = new Intl.DateTimeFormat("en-US", dateOptions);

    return {
      time: formatter.format(now).replace(/\s?[A-Z]{2,5}$/, " SV"),
      date: dateFormatter.format(now).replace(/(\d+)\/(\d+)\/(\d+)/, "$1/$2/$3")
    };
  }

  function updateClock() {
    const clock = getClockParts();

    document.querySelectorAll(".date").forEach(function (el) {
      el.textContent = clock.date;
    });

    document.querySelectorAll(".time").forEach(function (el) {
      el.textContent = clock.time;
    });
  }

function initClock() {
  updateClock();

  if (window.kolakClockInterval) {
    clearInterval(window.kolakClockInterval);
  }

  window.kolakClockInterval = setInterval(updateClock, 1000);
}

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initClock, { once: true });
  } else {
    initClock();
  }

  document.addEventListener("shopify:section:load", initClock);
  document.addEventListener("shopify:section:select", initClock);
})();
